import { render } from "./OpenNextRoundTaskDialog.vue?vue&type=template&id=ee3f99c8&scoped=true"
import script from "./OpenNextRoundTaskDialog.vue?vue&type=script&lang=js"
export * from "./OpenNextRoundTaskDialog.vue?vue&type=script&lang=js"

import "./OpenNextRoundTaskDialog.vue?vue&type=style&index=0&id=ee3f99c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee3f99c8"]])

export default __exports__